function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
import React from "react";
import PropTypes from "prop-types";
import { TooltipPortal } from "../TooltipPortal/TooltipPortal";
import styled, { css } from "styled-components";
import { ThemePropType } from "../../utils/themeProps";
/**
 * GhostButton renders an action button. GhostButton are styled in a fashion
 * that resembles UX ghost buttons (https://uxplanet.org/ghost-buttons-in-ux-design-4cf3717334f8)
 */

var Disabled = css(["border:1px solid ", ";color:", ";cursor:auto;&:focus{box-shadow:none;}&:hover{border:1px solid ", ";color:", ";background-color:transparent;cursor:auto;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.border;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.border;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.border;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.border;
});
var Active = css(["background-color:", ";color:", ";"], function (_ref5) {
  var alert = _ref5.alert,
    theme = _ref5.theme;
  return alert ? theme.alert : theme.secondary;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.white;
});
var Small = css(["font-size:12px;padding:4px 12px;max-height:30px;min-width:70px;"]);
var ReadOnly = css(["cursor:none;pointer-events:none;"]);
var Material = css(["min-width:0;font-size:14px;font-weight:400;line-height:36px;letter-spacing:0.14px;border:0;padding:0 8px;&:hover{color:", ";background-color:transparent;}"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.secondaryDark;
});
var Form = css(["font-size:12px;min-width:82px;padding:4px 10px;height:26px;border-radius:3px;letter-spacing:1.5px;&:focus{border-width:2px;padding:4px 9px;}"]);
var Primary = css(["font-weight:300;color:", ";border-color:", ";"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.primary;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.primary;
});
var Progress = css(["border-color:transparent;transition:background-color 0.2s ease 1.5s,color 0s ease 1s;background-color:transparent;color:", ";pointer-events:none;&:before{width:100%;background-color:transparent;}"], function (_ref10) {
  var alert = _ref10.alert,
    theme = _ref10.theme;
  return alert ? theme.alert : theme.secondary;
});
var BaseButton = styled.button.attrs({
  type: function type(_ref11) {
    var submit = _ref11.submit;
    return submit ? "submit" : "button";
  },
  className: function className(_ref12) {
    var _className = _ref12.className;
    return "ghost-button ".concat(_className);
  }
}).withConfig({
  displayName: "GhostButton__BaseButton"
})(["position:relative;font-family:Roboto Condensed,sans-serif;display:inline-block;text-align:center;font-size:14px;border-radius:3px;min-width:100px;padding:12px 22px;cursor:pointer;text-decoration:none;text-transform:uppercase;letter-spacing:1px;background-color:Transparent;transition:all 0.2s ease-in-out;outline:none;user-select:none;color:", ";border:1px solid ", ";background-color:transparent;&:before{content:\"\";position:absolute;width:0%;top:0;left:0;height:100%;transition:width 2s ease,background-color .2s ease 2s;background-color:", ";}&:focus{box-shadow:0 0 6px ", ";}&:hover{background-color:", ";color:", ";border-color:", ";}", " ", " ", " ", " ", " ", " ", " ", ""], function (_ref13) {
  var alert = _ref13.alert,
    theme = _ref13.theme;
  return alert ? theme.alert : theme.secondary;
}, function (_ref14) {
  var alert = _ref14.alert,
    theme = _ref14.theme;
  return alert ? theme.alert : theme.secondary;
}, function (_ref15) {
  var alert = _ref15.alert,
    theme = _ref15.theme;
  return alert ? theme.alert : theme.white;
}, function (_ref16) {
  var alert = _ref16.alert,
    theme = _ref16.theme;
  return alert ? theme.alert : theme.secondary;
}, function (_ref17) {
  var alert = _ref17.alert,
    theme = _ref17.theme;
  return alert ? theme.alert : theme.secondary;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.white;
}, function (_ref19) {
  var alert = _ref19.alert,
    theme = _ref19.theme;
  return alert ? theme.alert : theme.secondary;
}, function (_ref20) {
  var progress = _ref20.progress;
  return progress && Progress;
}, function (_ref21) {
  var primary = _ref21.primary;
  return primary && Primary;
}, function (_ref22) {
  var material = _ref22.material;
  return material && Material;
}, function (_ref23) {
  var form = _ref23.form;
  return form && Form;
}, function (_ref24) {
  var small = _ref24.small;
  return small && Small;
}, function (_ref25) {
  var readOnly = _ref25.readOnly;
  return readOnly && ReadOnly;
}, function (_ref26) {
  var active = _ref26.active;
  return active && Active;
}, function (_ref27) {
  var _disabled = _ref27._disabled;
  return _disabled && Disabled;
});
export var GhostButton = /*#__PURE__*/
function (_React$PureComponent) {
  _inherits(GhostButton, _React$PureComponent);
  function GhostButton() {
    _classCallCheck(this, GhostButton);
    return _possibleConstructorReturn(this, _getPrototypeOf(GhostButton).apply(this, arguments));
  }
  _createClass(GhostButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        theme = _this$props.theme,
        title = _this$props.title,
        styledComponentsTheme = _this$props.styledComponentsTheme,
        onClick = _this$props.onClick,
        disabled = _this$props.disabled,
        safeProps = _objectWithoutProperties(_this$props, ["theme", "title", "styledComponentsTheme", "onClick", "disabled"]);
      var alert = this.props.alert || theme === "alert";
      var material = this.props.material || this.props.className.match(/\b(material)\b/);
      var form = this.props.form || this.props.className.match(/\b(form)\b/);
      var button = React.createElement(BaseButton, _extends({}, safeProps, {
        onClick: disabled ? function () {} : onClick,
        _disabled: disabled,
        theme: styledComponentsTheme || undefined,
        alert: alert,
        material: material,
        form: form
      }));
      return title ? React.createElement(TooltipPortal, {
        content: title
      }, button) : button;
    }
  }]);
  return GhostButton;
}(React.PureComponent);
GhostButton.propTypes = {
  /** The message to be displayed into a tooltip when hovering. This can be a React component. */
  title: PropTypes.any,
  disabled: PropTypes.bool,
  small: PropTypes.bool,
  active: PropTypes.bool,
  submit: PropTypes.bool,
  onClick: PropTypes.func,
  /** If set to true renders a progress version of GhostButton */
  progress: PropTypes.bool,
  readOnly: PropTypes.bool,
  alert: PropTypes.bool,
  material: PropTypes.bool,
  form: PropTypes.bool,
  primary: PropTypes.bool,
  children: PropTypes.node,
  /** DEPRECATED: Please use the "alert" prop to set the theme to 'alert', this interferes */

  /** with actual StyledComponents themes */
  theme: PropTypes.string,
  /** This will eventually be the new "theme" prop */
  styledComponentsTheme: ThemePropType,
  /** ALERT: While classNames are still functional and will not ever be deprecated, it is important */

  /** to note that they should be used to extend the component for a specific use case if necessary */

  /** and NOT TO EXPAND THE FUNCTIONALITY OF THE COMPONENT FOR EVERYONE. If you wish to do that, add a new prop. */

  /** Also, if you're adding a "form" or "material" className, please use their respective props. */
  className: PropTypes.string
};
GhostButton.defaultProps = {
  theme: "mlp",
  className: "",
  onClick: function onClick() {}
};